import { Api } from '../api';
import { createUrl } from '../../helpers/uri-factory';

const url = createUrl('student');

export class StudentToken extends Api {
  constructor(http, config = {}) {
    super(http, url, 'token-benefit', config);
  }

}